import { ReactNode } from 'react';

import { Box, Button, Flex, Heading } from '@brand/components';

import { Link } from '@hoa/components/atoms';

interface Props {
  title: ReactNode;
  subTitle: ReactNode;
  button: ReactNode;
  url?: string;
}

export const CategoryPreFooter = ({ title, subTitle, button, url }: Props) => {
  return (
    <Box as="section" textAlign="center" py={20} bg="gray.100">
      <Heading as="h2" variant="h3" mb={10}>
        {title}
      </Heading>
      {subTitle && (
        <Heading as="h3" variant="h5" mb={8}>
          {subTitle}
        </Heading>
      )}
      <Flex justifyContent="center">
        <Link
          href={url}
          anchorProps={{
            _hover: {
              textDecoration: `none`,
            },
          }}
        >
          <Button>{button}</Button>
        </Link>
      </Flex>
    </Box>
  );
};
